<div id="tile-history-drawer">
  <div class="header">
    @if (!isLoadingView()) {
      <div
        [class.more-than-one]="datasets.length > 1"
        class="name"
      >
        <i class="fa-solid fa-chart-line"></i> {{title}}
      </div>
    } @else {
      <div class="name">
        <motn-spinner></motn-spinner>
      </div>
    }

    <div class="options">
      @if (isNumericTile) {
        <div class="options-pills">
          @if (showStackingOptions) {
            <div class="option-group">
              <motn-pill
                class="clickable color-hover"
                (click)="stackingMenuOpen = !stackingMenuOpen"
              ><i class="fa-regular fa-layer-group"></i>
                {{getStackingButtonText()}}</motn-pill>
              @if (stackingMenuOpen) {
                <motn-popover-menu
                  [optionGroup]="stackingOptions"
                  [menuTitle]="'Layout'"
                  (clickedOption$)="closeStackingMenu()"
                  (clickedOutsideMenu$)="closeStackingMenu()"
                ></motn-popover-menu>
              }
            </div>
          }

          <div class="option-group">
            <motn-pill
              class="clickable color-hover"
              (click)="intervalMenuOpen = !intervalMenuOpen"
            ><i class="fa-regular fa-ruler"></i>
              {{getIntervalButtonText()}}</motn-pill>
            @if (intervalMenuOpen) {
              <motn-popover-menu
                [optionGroup]="intervalOptions"
                [menuTitle]="'Interval'"
                (clickedOption$)="closeIntervalMenu()"
                (clickedOutsideMenu$)="closeIntervalMenu()"
              ></motn-popover-menu>
            }
          </div>

          <div class="option-group">
            <motn-pill
              class="clickable color-hover"
              (click)="timezoneMenuOpen = !timezoneMenuOpen"
            ><i class="fa-regular fa-globe"></i>
              {{getTimezoneButtonText()}}</motn-pill>
            @if (timezoneMenuOpen) {
              <motn-popover-menu
                [optionGroup]="timezoneOptions"
                [menuTitle]="'Timezone'"
                (clickedOption$)="closeTimezoneMenu()"
                (clickedOutsideMenu$)="closeTimezoneMenu()"
              ></motn-popover-menu>
            }
          </div>

          <!-- Time Range Menu -->
          <div class="option-group">
            <motn-pill
              class="clickable color-hover"
              (click)="timeRangeMenuOpen = !timeRangeMenuOpen"
            ><i class="fa-regular fa-timer"></i>
              {{timeRangeButtonText}}</motn-pill>
            @if (timeRangeMenuOpen) {
              <motn-popover-menu
                [optionGroup]="timeRangeOptions"
                [menuTitle]="'Time Range'"
                (clickedOption$)="closeTimeRangeMenu()"
                (clickedOutsideMenu$)="closeTimeRangeMenu()"
              ></motn-popover-menu>
            }
            @if (datePickerOpen) {
              <motn-datetime-range-picker
                [startValue]="datePickerStart"
                [endValue]="datePickerEnd"
                [maxDate]="maxDate"
                [getMaxEndDate]="getMaxEndDate"
                (rangeChange)="onRangeChange($event)"
                (closed$)="datePickerOpen = false"
              ></motn-datetime-range-picker>
            }
          </div>

          <!-- Navigation Pill -->
          <div class="option-group">
            <div class="pill split-pill">
              <span
                class="split-pill-side split-pill-left"
                (click)="!isLoadingView() && navigateOlder()"
                [class.disabled]="isLoadingView()"
                title="View older data"
              >
                <i class="fa-regular fa-chevron-left"></i>
                Older
              </span>
              <span
                class="split-pill-side split-pill-right"
                (click)="!isLoadingView() && canNavigateNewer() && navigateNewer()"
                [class.disabled]="isLoadingView() || !canNavigateNewer()"
                title="View newer data"
              >
                Newer
                <i class="fa-regular fa-chevron-right"></i>
              </span>
            </div>
          </div>

          <!-- CSV Export Button -->
          <div class="option-group">
            <motn-pill
              class="clickable color-hover"
              [disabled]="isCsvExportDisabled()"
              [title]="datasets.length > 1 ? 'CSV export only available for single tile' : 'Export to CSV'"
              (click)="exportToCsv()"
            ><i class="fa-regular fa-download"></i>
              CSV</motn-pill>
            @if (csvExportMenuOpen && datasets.length === 1) {
              <motn-popover-menu
                [optionGroup]="csvExportOptions"
                [menuTitle]="'CSV Export'"
                (clickedOption$)="closeCsvExportMenu()"
                (clickedOutsideMenu$)="closeCsvExportMenu()"
              ></motn-popover-menu>
            }
          </div>
        </div>
      }

      <button
        class="close-button"
        (click)="closeChart()"
      >
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>
  </div>

  @if (!isLoadingView() && hasNoData()) {
    <div class="empty-state">
      <i class="fa-regular fa-calendar-xmark empty-state-icon"></i>
      <p class="empty-state-text">No data for the selected range</p>
    </div>
  }

  @if (!isLoadingView() && showPartialRangeNotice) {
    <div class="truncated-notice">
      <i class="fa-solid fa-circle-info"></i>
      Showing {{historyQuantity}} values from this range.
    </div>
  }

  <motn-tile-history
    [datasets$]="datasets$"
    [timezone]="selectedTimezone"
  ></motn-tile-history>

</div>

@if (datasets.length) {
  <div id="tile-history-buffer"></div>
}
